import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../services/api";
import jsPDF from "jspdf";

const FicheCommercial = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [commercial, setCommercial] = useState(null);
  const [historique, setHistorique] = useState([]);
  const [simulation, setSimulation] = useState(null);
  const [loading, setLoading] = useState(true);
  const [simLoading, setSimLoading] = useState(false);
  const [onglet, setOnglet] = useState("fiche");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [comRes, histRes] = await Promise.all([
          api.get(`/commercials/${id}`),
          api.get(`/commercials/${id}/historique`),
        ]);
        setCommercial(comRes.data || null);
        setHistorique(histRes.data || []);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id]);

  const handleSimuler = async () => {
    setSimLoading(true);
    try {
      const res = await api.get(`/commercials/${id}/salaire/simuler`);
      setSimulation(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setSimLoading(false);
    }
  };

  const handleImprimer = () => {
    const mois = simulation?.mois;
    const annee = simulation?.annee;
    const moisNom = ["Janvier","Fevrier","Mars","Avril","Mai","Juin","Juillet","Aout","Septembre","Octobre","Novembre","Decembre"][mois - 1] || "";
    const dateGen = new Date().toLocaleDateString("fr-FR");

    // Nettoyer les caractères non supportés par jsPDF
    const clean = (txt) => {
      if (!txt) return "";
      let s = String(txt);
      s = s.replace(/\u00e9|\u00e8|\u00ea|\u00eb/g, "e");
      s = s.replace(/\u00e0|\u00e2|\u00e4/g, "a");
      s = s.replace(/\u00ee|\u00ef/g, "i");
      s = s.replace(/\u00f4|\u00f6/g, "o");
      s = s.replace(/\u00f9|\u00fb|\u00fc/g, "u");
      s = s.replace(/\u00e7/g, "c");
      s = s.replace(/\u00c9|\u00c8/g, "E");
      s = s.replace(/\u00c0|\u00c2/g, "A");
      s = s.replace(/\u00ce/g, "I");
      s = s.replace(/\u00d4/g, "O");
      s = s.replace(/\u00db|\u00d9/g, "U");
      s = s.replace(/\u00c7/g, "C");
      s = s.replace(/\u00d7/g, "x");
      s = s.replace(/\u2192/g, "->");
      s = s.replace(/\u2265/g, ">=");
      s = s.replace(/\u2264/g, "<=");
      s = s.replace(/\u2013|\u2014/g, "-");
      s = s.replace(/\u00b0/g, " deg");
      s = s.replace(/\u2018|\u2019/g, "'");
      s = s.replace(/\u201c|\u201d/g, '"');
      //s = s.replace(/[^\u0000-\u007F]/g, "");
      return s;
    };

    // Formater les nombres
    const fmt = (n) => {
      const num = Math.round(Number(n) || 0);
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " F";
    };

    const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
    const pageW = doc.internal.pageSize.getWidth();
    const margin = 20;
    const contentW = pageW - margin * 2;
    let y = 20;

    const violet = [124, 58, 237];
    const gris = [107, 114, 128];
    const noir = [17, 24, 39];
    const bleu = [24, 95, 165];
    const rouge = [220, 38, 38];
    const vert = [22, 163, 74];

    // En-tête
    doc.setFontSize(18);
    doc.setTextColor(...noir);
    doc.setFont("helvetica", "bold");
    doc.text("Fiche de salaire", margin, y);
    y += 8;
    doc.setFontSize(13);
    doc.setFont("helvetica", "normal");
    doc.text(clean(`${commercial?.prenom} ${commercial?.nom}`), margin, y);
    y += 6;
    doc.setFontSize(10);
    doc.setTextColor(...gris);
    doc.text(clean(`Periode : ${moisNom} ${annee}  -  Generee le ${dateGen}`), margin, y);
    y += 10;

    doc.setDrawColor(229, 231, 235);
    doc.line(margin, y, pageW - margin, y);
    y += 8;

    // Section Ventes
    doc.setFontSize(12);
    doc.setTextColor(...violet);
    doc.setFont("helvetica", "bold");
    doc.text("Ventes du mois", margin, y);
    y += 2;
    doc.setDrawColor(...violet);
    doc.line(margin, y, pageW - margin, y);
    y += 6;

    const colW = contentW / 3;
    const stats = [
      { label: "Jours travailles", value: String(simulation?.ventes?.joursTravailles || 0), color: noir },
      { label: "Coupons vendus", value: String(simulation?.ventes?.couponsTotal || 0), color: bleu },
      { label: "Moyenne/jour", value: String(simulation?.ventes?.moyenneCoupons || 0), color: noir },
    ];
    stats.forEach((s, i) => {
      const x = margin + i * colW;
      doc.setFillColor(249, 250, 251);
      doc.roundedRect(x, y, colW - 4, 20, 2, 2, "F");
      doc.setFontSize(9);
      doc.setTextColor(...gris);
      doc.setFont("helvetica", "normal");
      doc.text(s.label, x + 4, y + 6);
      doc.setFontSize(16);
      doc.setTextColor(...s.color);
      doc.setFont("helvetica", "bold");
      doc.text(s.value, x + 4, y + 16);
    });
    y += 28;

    // Section Prime
    doc.setFontSize(12);
    doc.setTextColor(...violet);
    doc.setFont("helvetica", "bold");
    doc.text("Calcul de la prime", margin, y);
    y += 2;
    doc.setDrawColor(...violet);
    doc.line(margin, y, pageW - margin, y);
    y += 6;

    doc.setFontSize(10);
    doc.setTextColor(...gris);
    doc.setFont("helvetica", "normal");
    const explication = clean(simulation?.calcul_prime?.explication || "-");
    const expLines = doc.splitTextToSize(explication, contentW);
    doc.text(expLines, margin, y);
    y += expLines.length * 5 + 4;

    const prime = Number(simulation?.calcul_prime?.prime_totale || 0);
    doc.setFontSize(13);
    doc.setTextColor(...(prime > 0 ? vert : gris));
    doc.setFont("helvetica", "bold");
    doc.text(`Prime : ${fmt(prime)}`, margin, y);
    y += 12;

    // Section Résultat
    doc.setFontSize(12);
    doc.setTextColor(...violet);
    doc.setFont("helvetica", "bold");
    doc.text("Resultat", margin, y);
    y += 2;
    doc.setDrawColor(...violet);
    doc.line(margin, y, pageW - margin, y);
    y += 6;

    doc.setFillColor(243, 232, 255);
    doc.roundedRect(margin, y, contentW, 35, 3, 3, "F");

    doc.setFontSize(9);
    doc.setTextColor(...gris);
    doc.setFont("helvetica", "normal");
    const detail = clean(simulation?.detail || "");
    const detailLines = doc.splitTextToSize(detail, contentW - 8);
    doc.text(detailLines, margin + 4, y + 6);

    const boxY = y + 18;
    doc.setFontSize(10);
    doc.setTextColor(...gris);
    doc.text("Dette", margin + 4, boxY);
    doc.setFontSize(13);
    doc.setTextColor(...rouge);
    doc.setFont("helvetica", "bold");
    doc.text(fmt(simulation?.dette || 0), margin + 4, boxY + 7);

    doc.setFontSize(10);
    doc.setTextColor(...gris);
    doc.setFont("helvetica", "normal");
    doc.text("Salaire net", margin + 60, boxY);
    doc.setFontSize(16);
    doc.setTextColor(...violet);
    doc.setFont("helvetica", "bold");
    doc.text(fmt(simulation?.salaireNet || 0), margin + 60, boxY + 8);
    y += 44;

    // Footer
    doc.setFontSize(9);
    doc.setTextColor(...gris);
    doc.setFont("helvetica", "normal");
    doc.text("Banque Bleue - Document genere automatiquement", pageW / 2, 285, { align: "center" });

    const nomFichier = `salaire_${commercial?.nom}_${commercial?.prenom}_${moisNom}_${annee}.pdf`;
    doc.save(clean(nomFichier));
  };

  const moisLabel = (mois) => {
    const labels = ["Jan", "Fév", "Mar", "Avr", "Mai", "Jun", "Jul", "Aoû", "Sep", "Oct", "Nov", "Déc"];
    return labels[mois - 1] || mois;
  };

  if (loading) return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "60vh" }}>
      <div style={{ width: "36px", height: "36px", border: "3px solid #f3e8ff", borderTop: "3px solid #7c3aed", borderRadius: "50%", animation: "spin 1s linear infinite" }} />
    </div>
  );

  if (!commercial) return (
    <div style={{ padding: "2rem", textAlign: "center", color: "#dc2626" }}>Commercial introuvable</div>
  );

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "1.5rem" }}>
        <button onClick={() => navigate("/admin/commerciaux")} style={{ background: "none", border: "none", cursor: "pointer", color: "#6b7280", display: "flex", alignItems: "center", gap: "4px", fontSize: "13px", padding: 0 }}>
          <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="15 18 9 12 15 6"/></svg>
          Retour
        </button>
        <div>
          <h1 style={{ fontSize: "18px", fontWeight: "500", color: "#111827", margin: 0 }}>{commercial.prenom} {commercial.nom}</h1>
          <span style={{ fontSize: "12px", backgroundColor: commercial.actif ? "#E6F1FB" : "#f3f4f6", color: commercial.actif ? "#185FA5" : "#6b7280", padding: "2px 8px", borderRadius: "6px" }}>
            {commercial.actif ? "Actif" : "Archivé"}
          </span>
        </div>
      </div>

      <div style={{ display: "flex", gap: "4px", marginBottom: "1.25rem", borderBottom: "1px solid #e5e7eb" }}>
        {[{ id: "fiche", label: "Fiche" }, { id: "historique", label: "Historique salaires" }, { id: "simulation", label: "Simuler salaire" }].map(o => (
          <button key={o.id} onClick={() => setOnglet(o.id)} style={{ padding: "0.65rem 1.25rem", background: "none", border: "none", cursor: "pointer", fontSize: "13px", fontWeight: onglet === o.id ? "500" : "400", color: onglet === o.id ? "#7c3aed" : "#6b7280", borderBottom: onglet === o.id ? "2px solid #7c3aed" : "2px solid transparent", marginBottom: "-1px" }}>
            {o.label}
          </button>
        ))}
      </div>

      {onglet === "fiche" && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "12px" }}>
          {[
            { label: "Clients", value: commercial.nb_clients },
            { label: "Crédits octroyés", value: commercial.nombre_credits_octroyes },
            { label: "Coupons vendus", value: commercial.nombre_coupons_vendus },
            { label: "Solde actuel", value: `${Number(commercial.solde).toLocaleString("fr-FR")} F` },
            { label: "Crédits remb. ce mois", value: commercial.credits_rembourses_mois, color: "#16a34a" },
            { label: "Crédits non remb.", value: commercial.credits_non_rembourses, color: commercial.credits_non_rembourses > 0 ? "#dc2626" : "#9ca3af" },
            { label: "Dette totale", value: commercial.dette_totale > 0 ? `${Number(commercial.dette_totale).toLocaleString("fr-FR")} F` : "—", color: commercial.dette_totale > 0 ? "#ea580c" : "#9ca3af" },
            { label: "Pénalités récup.", value: commercial.penalites_recuperees > 0 ? `${Number(commercial.penalites_recuperees).toLocaleString("fr-FR")} F` : "—", color: "#16a34a" },
            { label: "Salaire net estimé", value: `${Number(commercial.salaire_net_estime).toLocaleString("fr-FR")} F`, color: "#7c3aed" },
          ].map((stat, i) => (
            <div key={i} style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "12px", padding: "1rem" }}>
              <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "6px" }}>{stat.label}</div>
              <div style={{ fontSize: "20px", fontWeight: "500", color: stat.color || "#111827" }}>{stat.value}</div>
            </div>
          ))}
        </div>
      )}

      {onglet === "historique" && (
        <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", overflow: "hidden" }}>
          {historique.length === 0 ? (
            <div style={{ padding: "3rem", textAlign: "center" }}>
              <div style={{ fontSize: "2rem", marginBottom: "0.5rem" }}>📋</div>
              <p style={{ color: "#6b7280", fontSize: "14px" }}>Aucun historique disponible</p>
            </div>
          ) : (
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
                <thead>
                  <tr style={{ backgroundColor: "#f9fafb" }}>
                    {["Période", "Jours trav.", "Coupons", "Moyenne/j", "Salaire base", "Prime", "Dette", "Salaire net"].map(h => (
                      <th key={h} style={{ padding: "0.75rem 1rem", textAlign: "left", fontSize: "11px", color: "#6b7280", fontWeight: "500", whiteSpace: "nowrap" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {historique.map((row, i) => (
                    <tr key={i} style={{ borderTop: "0.5px solid #f3f4f6" }}
                      onMouseEnter={e => e.currentTarget.style.backgroundColor = "#f9fafb"}
                      onMouseLeave={e => e.currentTarget.style.backgroundColor = "transparent"}>
                      <td style={{ padding: "0.75rem 1rem", fontWeight: "500", color: "#111827" }}>{moisLabel(row.mois)} {row.annee}</td>
                      <td style={{ padding: "0.75rem 1rem" }}>{row.jours_travailles}</td>
                      <td style={{ padding: "0.75rem 1rem" }}><span style={{ backgroundColor: "#E6F1FB", color: "#185FA5", padding: "2px 8px", borderRadius: "6px", fontWeight: "500" }}>{row.coupons_total}</span></td>
                      <td style={{ padding: "0.75rem 1rem" }}>{row.moyenne_coupons}</td>
                      <td style={{ padding: "0.75rem 1rem", whiteSpace: "nowrap" }}>{Number(row.salaire_base).toLocaleString("fr-FR")} F</td>
                      <td style={{ padding: "0.75rem 1rem", color: "#16a34a", whiteSpace: "nowrap" }}>{row.prime > 0 ? `+${Number(row.prime).toLocaleString("fr-FR")} F` : "—"}</td>
                      <td style={{ padding: "0.75rem 1rem", color: row.dette > 0 ? "#dc2626" : "#9ca3af", whiteSpace: "nowrap" }}>{row.dette > 0 ? `-${Number(row.dette).toLocaleString("fr-FR")} F` : "—"}</td>
                      <td style={{ padding: "0.75rem 1rem", fontWeight: "500", color: "#7c3aed", whiteSpace: "nowrap" }}>{Number(row.salaire_net).toLocaleString("fr-FR")} F</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      )}

      {onglet === "simulation" && (
        <div>
          <div style={{ display: "flex", gap: "12px", marginBottom: "1.25rem", alignItems: "center", flexWrap: "wrap" }}>
            <button onClick={handleSimuler} disabled={simLoading} style={{ padding: "0.75rem 2rem", background: "linear-gradient(135deg, #7c3aed, #9333ea)", color: "white", fontWeight: "500", fontSize: "14px", borderRadius: "9999px", border: "none", cursor: simLoading ? "not-allowed" : "pointer", opacity: simLoading ? 0.7 : 1 }}>
              {simLoading ? "Calcul en cours..." : "Simuler le salaire du mois"}
            </button>
            {simulation && (
              <button onClick={handleImprimer} style={{ padding: "0.75rem 1.5rem", background: "white", color: "#7c3aed", fontWeight: "500", fontSize: "14px", borderRadius: "9999px", border: "1.5px solid #7c3aed", cursor: "pointer", display: "flex", alignItems: "center", gap: "8px" }}>
                <svg width="14" height="14" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><polyline points="6 9 6 2 18 2 18 9"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>
                Telecharger PDF
              </button>
            )}
          </div>

          {simulation && (
            <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
              <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", padding: "1.25rem" }}>
                <div style={{ fontSize: "14px", fontWeight: "500", color: "#111827", marginBottom: "1rem" }}>Ventes — {moisLabel(simulation.mois)} {simulation.annee}</div>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "12px" }}>
                  <div><div style={{ fontSize: "12px", color: "#6b7280" }}>Jours travaillés</div><div style={{ fontSize: "20px", fontWeight: "500" }}>{simulation.ventes?.joursTravailles}</div></div>
                  <div><div style={{ fontSize: "12px", color: "#6b7280" }}>Coupons total</div><div style={{ fontSize: "20px", fontWeight: "500", color: "#185FA5" }}>{simulation.ventes?.couponsTotal}</div></div>
                  <div><div style={{ fontSize: "12px", color: "#6b7280" }}>Moyenne/jour</div><div style={{ fontSize: "20px", fontWeight: "500" }}>{simulation.ventes?.moyenneCoupons}</div></div>
                </div>
              </div>
              <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", padding: "1.25rem" }}>
                <div style={{ fontSize: "14px", fontWeight: "500", color: "#111827", marginBottom: "0.75rem" }}>Calcul de la prime</div>
                <p style={{ fontSize: "13px", color: "#6b7280", margin: "0 0 0.75rem" }}>{simulation.calcul_prime?.explication}</p>
                <div style={{ fontSize: "18px", fontWeight: "500", color: simulation.calcul_prime?.prime_totale > 0 ? "#16a34a" : "#9ca3af" }}>
                  Prime : {Number(simulation.calcul_prime?.prime_totale || 0).toLocaleString("fr-FR")} F
                </div>
              </div>
              <div style={{ backgroundColor: "#f3e8ff", border: "1px solid #e9d5ff", borderRadius: "16px", padding: "1.25rem" }}>
                <div style={{ fontSize: "14px", fontWeight: "500", color: "#7c3aed", marginBottom: "0.75rem" }}>Résultat</div>
                <p style={{ fontSize: "13px", color: "#6b7280", margin: "0 0 0.75rem", fontFamily: "monospace" }}>{simulation.detail}</p>
                <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
                  <div><div style={{ fontSize: "11px", color: "#9ca3af" }}>Dette</div><div style={{ fontSize: "16px", fontWeight: "500", color: "#dc2626" }}>{Number(simulation.dette || 0).toLocaleString("fr-FR")} F</div></div>
                  <div><div style={{ fontSize: "11px", color: "#9ca3af" }}>Salaire net</div><div style={{ fontSize: "22px", fontWeight: "500", color: "#7c3aed" }}>{Number(simulation.salaireNet || 0).toLocaleString("fr-FR")} F</div></div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default FicheCommercial;